import React, { Component } from 'react';

import i18n from '../../../shared/locales/no.json';
import Broadcast from '../spaden/molecules/Broadcast';

class NoAccess extends Component {
    render() {
        return (
            <Broadcast className="bg-salmon cherry pam">
                <span className="r-phm">
                    <span className="caption showbydefault mls">
                        {i18n.global.noAccess}
                    </span>
                </span>
            </Broadcast>
        );
    }
}

export default NoAccess;
